import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const HikisariKekkaKbn = props => {
  return <Dropdown.Static kubunKey='hikisari_kekka_kbn' {...props} />
}
